import React from "react";

export default function Footer() {
  return (
    <footer className="bg-[#2074D9] text-white pt-8 max-[768px]:pb-8">
      <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
        <div className="mb-4 md:mb-0">
          <img
            src="./assets/icons/Logo.png"
            alt="Randstad Logo"
            className="h-12"
          />
        </div>

        <div className="text-left md:text-left mb-4 md:mb-0">
          <p className="mb-2">
            Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
            Brasil sob CNPJ 03.573.863/000
          </p>
          <p>
            Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
            20º andar / CEP: 05001-100
          </p>
          <p>
            A Randstad trata dados pessoais de acordo com a LGPD (Lei
            13.709/18). Leia nosso{" "}
            <a
              href="https://www.randstad.com.br/sobre-sua-privacidade/"
              target="_blank"
              className="text-white underline hover:no-underline"
              rel="noreferrer"
            >
              Aviso de Privacidade
            </a>
            .
          </p>
        </div>

        <div className="flex space-x-4">
          <a
            href="https://www.linkedin.com/company/randstad-brasil/"
            target="_blank"
            className="w-8 h-8 flex items-center justify-center"
            rel="noreferrer"
          >
            <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
          </a>
          <a
            href="https://www.youtube.com/user/randstadbrasil/featured"
            target="_blank"
            className="w-8 h-8 flex items-center justify-center"
            rel="noreferrer"
          >
            <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
          </a>
          <a
            href="https://www.facebook.com/RandstadBR/"
            target="_blank"
            className="w-8 h-8 flex items-center justify-center"
            rel="noreferrer"
          >
            <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
          </a>
          <a
            href="https://www.instagram.com/randstadbr/"
            target="_blank"
            className="w-8 h-8 flex items-center justify-center"
            rel="noreferrer"
          >
            <img src="./assets/icons/instagram-logo.png" alt="Instagram Logo" />
          </a>
        </div>
      </div>
    </footer>
  );
}
